module.exports = __webpack_public_path__ + "static/media/fahrverbot.afed5104.svg";